import { create } from 'axios'

const bizoo = create({
  baseURL: process.env.VUE_APP_MASTER_API_URL_BASE,
})

const giggle = create({
  baseURL: process.env.VUE_APP_QUERY_API_URL_BASE,
})

const mouse = create({
  baseURL: process.env.VUE_APP_MOUSE_API_URL_BASE,
})

const rawHttp = create()

async function requestInterceptor(config) {
  const savedToken = await window.ssoClient.getToken()

  if (!savedToken.accessToken) {
    location.reload()
    return
  }

  config.headers.Authorization = `Bearer ${savedToken.accessToken}`

  return config
}

function responseInterceptor(response) {
  return response
}

async function errorResponseInterceptor(error) {
  // NOP トークン管理をこのプロジェクトで行っていたときはリフレッシュ
  //     失敗などの対処をここで行っていましたが、今はクライアントライブラリ
  //     でリフレッシュの失敗などは対処しているのでここでは何もしません。
  throw error
}

bizoo.interceptors.request.use(requestInterceptor)
giggle.interceptors.request.use(requestInterceptor)
mouse.interceptors.request.use(requestInterceptor)

bizoo.interceptors.response.use(responseInterceptor, errorResponseInterceptor)
giggle.interceptors.response.use(responseInterceptor, errorResponseInterceptor)
mouse.interceptors.response.use(responseInterceptor, errorResponseInterceptor)

export default { bizoo, giggle, mouse, rawHttp }
